import LayoutPadrao from 'lg-vue-components/layoutPadrao'
export default [
  {
    path: '/',
    redirect: 'cerca-eletronica',
    component: LayoutPadrao,
    children: [
      {
        path: '/cerca-eletronica',
        name: 'cerca-eletronica',
        component: () => import('./pages/ListarCercaEletronica')
      }
    ]
  },
  {
    path: '/',
    redirect: 'cerca-eletronica',
    component: LayoutPadrao,
    children: [
      {
        path: '/cerca-eletronica/:id',
        name: 'cerca-eletronica-editar',
        component: () => import('./pages/EditarCercaEletronica')
      }
    ]
  }
]
